export const styles = ({ palette }) => ({
  labelStyle: {
    color: palette.text.secondary,
  },
  datasetTitle: {
    margin: '0 25px',
  },
  ownerName: {
    fontWeight: 500, 
    color: palette.koalaGrey,
  },
  textEllipsis: {
    overflow: 'hidden', 
    textOverflow: 'ellipsis', 
    whiteSpace: 'nowrap',
  },
  datasetNameWrapper: {
    maxWidth: 350,
  },
  expiredLabel: {
    marginLeft: 30,
    marginBottom: 15,
  },
  alert: {
    maxWidth: 370,
    margin: '0 16px 16px',
  },
});
